import { isFinite } from "lodash";

function _defaultNum(num) {
  return isFinite(num) ? num : 0;
}

export function toPounds(pence) {
  return parseInt(_defaultNum(pence), 10) / 100;
}
export function toPence(pounds) {
  return Math.round(_defaultNum(parseFloat(pounds)) * 100);
}
export function formatPounds(pounds) {
  return `£${_defaultNum(pounds).toFixed(2)}`;
}